import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';

import { CommonDataService } from '@app/services/common-data/common-data.service';
import { PortalAutoQuoteContextService } from '@app/services/portal-auto-quote/portal-auto-quote-context.service';
import { Tracking } from '@app/services/tracking/tracking.service';
import { PortalTrackingEvents } from '@app/utils/tracking-events';

@Component({
  selector: 'quote-expired-page',
  templateUrl: './quote-expired-page.component.html',
  styleUrls: ['./quote-expired-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuoteExpiredPageComponent implements OnInit, OnDestroy {
  commonDataService = inject(CommonDataService);
  autoQuoteContext = inject(PortalAutoQuoteContextService);

  autoQuote$ = this.autoQuoteContext.getAutoQuote$();

  ngOnInit() {
    Tracking.track(PortalTrackingEvents.portalAutoQuoteExpiredPageOpened);
  }

  callExpertPressed() {
    Tracking.track(PortalTrackingEvents.portalAutoQuoteExpiredCallExpertPressed);
  }

  ngOnDestroy() {
    this.autoQuoteContext.clear();
  }
}
